import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as outcomes from '../../../../outcomes'
import * as source from '../source'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: source.RESOURCE.payload.dimension.partialId,
      partialId: source.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Outcome that the external source is linked to',
    isOptional: false,
    name: 'Outcome',
    partialId: PartialId.Standard.create('outcome'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(outcomes.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
